import { InjectionToken } from '@angular/core';

/**
 * Bridge to the AngularJS `md5` service (provided by the `angular-md5`
 * package, GitHub: gdi2290/angular-md5#v0.1.10).
 *
 * Used by PermissionsService.fetchMD5() to compute a stable checksum of the
 * permissions map. Kept synchronous on purpose to preserve the legacy contract.
 */
export interface IMd5Port {
  createHash(input: string): string;
}

export const MD5_PORT = new InjectionToken<IMd5Port>('MD5_PORT');
